// src/sectors/pilates/members/modal/detail/hooks/useMemberPayments.js
import React from 'react';
import { membersApi } from 'sectors/pilates/members/api/membersApi';
import { normalizePayments } from '../utils/memberDetailUtils';

export function useMemberPayments(memberId, open) {
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState(null);
  const [payments, setPayments] = React.useState([]);

  const fetchPayments = React.useCallback(async () => {
    if (!memberId) return;
    try {
      setErr(null);
      setLoading(true);

      const res = await membersApi.payments(memberId);
      const arr = normalizePayments(res);

      arr.sort(
        (a, b) =>
          new Date(b?.createdAt || b?.paidDate || 0) - new Date(a?.createdAt || a?.paidDate || 0)
      );

      setPayments(arr);
    } catch (e) {
      console.error('membersApi.payments failed:', e);
      setErr(e?.message || 'Ödemeler yüklenemedi.');
      setPayments([]);
    } finally {
      setLoading(false);
    }
  }, [memberId]);

  React.useEffect(() => {
    if (open && memberId) fetchPayments();
    if (!open) {
      setErr(null);
      setLoading(false);
      setPayments([]);
    }
  }, [open, memberId, fetchPayments]);

  return { loading, err, payments, fetchPayments };
}
